/**
 * Main JS - Shopify theme utilities
 */

// ─── Toast Notification ──────────────────────────────────
function showToast(message, type) {
  type = type || 'info';
  var container = document.getElementById('toast-container') || createToastContainer();
  var toast = document.createElement('div');
  toast.className = 'toast-notification toast-' + type;
  toast.innerHTML = '<span>' + escapeHtml(message) + '</span><button onclick="this.parentElement.remove()">&times;</button>';
  container.appendChild(toast);
  setTimeout(function () { if (toast.parentElement) toast.remove(); }, 3000);
}

function createToastContainer() {
  var container = document.createElement('div');
  container.id = 'toast-container';
  document.body.appendChild(container);
  return container;
}

// ─── HTML Escaping ───────────────────────────────────────
function escapeHtml(str) {
  if (!str) return '';
  return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}

// ─── Scroll to Top ───────────────────────────────────────
function initScrollButton() {
  var btn = document.getElementById('scroll-top-btn');
  if (!btn) return;
  window.addEventListener('scroll', function () {
    btn.style.display = window.scrollY > 300 ? 'block' : 'none';
  });
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

// ─── AJAX Add to Cart ────────────────────────────────────
function ajaxAddToCart(variantId, btn) {
  if (!variantId || btn.disabled) return;
  var originalHTML = btn.innerHTML;
  btn.disabled = true;
  btn.querySelector('span').textContent = 'Adding…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: String(variantId), quantity: 1 })
  })
  .then(function (r) { return r.json(); })
  .then(function (data) {
    if (data.status) throw new Error(data.description || 'Could not add to cart');
    return fetch('/cart.js');
  })
  .then(function (r) { return r.json(); })
  .then(function (cart) {
    updateCartBadge(cart.item_count);
    showToast('Added to cart!', 'success');
    btn.querySelector('span').textContent = '✓ Added';
    setTimeout(function () {
      btn.disabled = false;
      btn.innerHTML = originalHTML;
    }, 1800);
  })
  .catch(function (err) {
    btn.disabled = false;
    btn.innerHTML = originalHTML;
    showToast(err.message || 'Could not add to cart', 'error');
  });
}

function updateCartBadge(count) {
  document.querySelectorAll('.cart-count-badge').forEach(function (el) {
    el.textContent = count;
    el.style.display = count > 0 ? '' : 'none';
  });
}

// ─── Wishlist (localStorage) ─────────────────────────────
var Wishlist = {
  _key: 'pk_wishlist',

  get: function () {
    try { return JSON.parse(localStorage.getItem(this._key) || '[]'); } catch (e) { return []; }
  },

  has: function (id) {
    return this.get().indexOf(String(id)) !== -1;
  },

  toggle: function (id) {
    var list = this.get();
    var sid = String(id);
    var idx = list.indexOf(sid);
    if (idx === -1) { list.push(sid); } else { list.splice(idx, 1); }
    localStorage.setItem(this._key, JSON.stringify(list));
    return idx === -1; // true = added
  },

  remove: function (id) {
    var list = this.get();
    var sid = String(id);
    var idx = list.indexOf(sid);
    if (idx !== -1) {
      list.splice(idx, 1);
      localStorage.setItem(this._key, JSON.stringify(list));
    }
  },

  count: function () { return this.get().length; },

  // Migrate: clear any old numeric-ID entries (from before handle-based storage)
  migrate: function () {
    var list = this.get();
    var cleaned = list.filter(function (item) { return !/^\d+$/.test(item); });
    if (cleaned.length !== list.length) {
      localStorage.setItem(this._key, JSON.stringify(cleaned));
    }
  }
};

function initWishlist() {
  // Clear any old numeric-ID-based entries from before handle-based storage
  Wishlist.migrate();

  // Update all heart icons on page load
  document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
    var pid = btn.dataset.pid;
    if (!pid) return;
    var icon = btn.querySelector('i');
    if (Wishlist.has(pid)) {
      btn.style.color = '#ff4d4d';
      if (icon) icon.className = 'ri-heart-fill';
    }
  });

  // Update badge counts
  updateWishlistBadge();

  // Attach click handlers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-btn');
    if (!btn) return;
    e.preventDefault();
    var pid = btn.dataset.pid;
    if (!pid) return;
    var added = Wishlist.toggle(pid);
    var icon = btn.querySelector('i');
    btn.style.color = added ? '#ff4d4d' : '#333';
    if (icon) icon.className = added ? 'ri-heart-fill' : 'ri-heart-line';
    showToast(added ? 'Added to wishlist!' : 'Removed from wishlist', added ? 'success' : 'info');
    updateWishlistBadge();
  });
}

function updateWishlistBadge() {
  var count = Wishlist.count();
  document.querySelectorAll('.wishlist-count-badge').forEach(function (el) {
    el.textContent = count;
  });
}

// ─── Header Handlers ─────────────────────────────────────
function initHeaderHandlers() {
  // Search overlay toggle
  var searchToggle = document.getElementById('search-toggle');
  if (searchToggle) {
    searchToggle.addEventListener('click', openSearchOverlay);
  }

  // Close search on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearchOverlay();
  });

  // Close search when clicking backdrop
  var searchOverlay = document.getElementById('search-overlay');
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) closeSearchOverlay();
    });
  }

  // Live search suggestions
  var searchInput = document.getElementById('header-search-input');
  var suggestTimer = null;
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(suggestTimer);
      var q = this.value.trim();
      if (q.length < 2) {
        document.getElementById('search-suggestions').innerHTML = '';
        document.getElementById('search-footer').style.display = 'none';
        return;
      }
      suggestTimer = setTimeout(function () { fetchSearchSuggestions(q); }, 300);
    });
  }

  // Search form submit → navigate to /collections/all?q=term
  var searchForm = document.getElementById('search-overlay-form');
  if (searchForm) {
    searchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = document.getElementById('header-search-input').value.trim();
      if (q) {
        window.location.href = '/collections/all?q=' + encodeURIComponent(q);
      }
    });
  }

  // Mobile menu handlers
  var mobileToggle = document.getElementById('mobile-menu-toggle');
  if (mobileToggle) mobileToggle.addEventListener('click', openMobileMenu);

  var closeBtn = document.querySelector('.bb-close-menu');
  if (closeBtn) closeBtn.addEventListener('click', closeMobileMenu);

  var overlay = document.getElementById('mobile-menu-overlay');
  if (overlay) overlay.addEventListener('click', closeMobileMenu);

  document.querySelectorAll('.mobile-has-sub > a').forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      var sub = this.nextElementSibling;
      if (!sub || sub.tagName !== 'UL') return;
      e.preventDefault();
      var li = this.parentElement;
      var isOpen = li.classList.contains('open');
      document.querySelectorAll('.mobile-has-sub.open').forEach(function (el) {
        el.classList.remove('open');
        var s = el.querySelector('.sub-menu');
        if (s) s.style.display = 'none';
      });
      if (!isOpen) {
        li.classList.add('open');
        sub.style.display = 'block';
      }
    });
  });
}

// ─── Search Overlay ──────────────────────────────────────
function openSearchOverlay() {
  var overlay = document.getElementById('search-overlay');
  if (overlay) {
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      var input = document.getElementById('header-search-input');
      if (input) input.focus();
    }, 100);
  }
}

function closeSearchOverlay() {
  var overlay = document.getElementById('search-overlay');
  if (overlay) {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    var input = document.getElementById('header-search-input');
    if (input) input.value = '';
    document.getElementById('search-suggestions').innerHTML = '';
    document.getElementById('search-footer').style.display = 'none';
  }
}

function fetchSearchSuggestions(query) {
  fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      var container = document.getElementById('search-suggestions');
      var footer = document.getElementById('search-footer');

      if (products.length === 0) {
        container.innerHTML = '<div style="padding:20px;text-align:center;color:#999;font-size:14px;">No products found</div>';
        footer.style.display = 'none';
        return;
      }

      var html = products.map(function (p) {
        var price = p.price ? '₹' + (parseInt(p.price) / 100).toFixed(2) : '';
        var img = p.image || '';
        return '<a href="' + p.url + '" class="search-suggestion-item" onclick="closeSearchOverlay()">' +
          '<img src="' + img + '" alt="" class="search-suggestion-img">' +
          '<div class="search-suggestion-info">' +
            '<div class="search-suggestion-title">' + escapeHtml(p.title) + '</div>' +
            '<div class="search-suggestion-price">' + price + '</div>' +
          '</div>' +
        '</a>';
      }).join('');

      container.innerHTML = html;
      footer.style.display = 'block';

      // Update "View all" link
      var viewAll = document.getElementById('search-view-all');
      if (viewAll) {
        viewAll.href = '/search/' + encodeURIComponent(query);
        viewAll.onclick = function () { closeSearchOverlay(); };
      }
    })
    .catch(function () {
      document.getElementById('search-suggestions').innerHTML = '';
      document.getElementById('search-footer').style.display = 'none';
    });
}

function openMobileMenu() {
  var menu = document.getElementById('bb-mobile-menu');
  var overlay = document.getElementById('mobile-menu-overlay');
  if (menu) menu.classList.add('bb-menu-open');
  if (overlay) overlay.style.display = 'block';
  document.body.style.overflow = 'hidden';
}

function closeMobileMenu() {
  var menu = document.getElementById('bb-mobile-menu');
  var overlay = document.getElementById('mobile-menu-overlay');
  if (menu) menu.classList.remove('bb-menu-open');
  if (overlay) overlay.style.display = 'none';
  document.body.style.overflow = '';
}

// ─── Init ────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  initScrollButton();
  initWishlist();
  initHeaderHandlers();

  if (typeof AOS !== 'undefined') {
    AOS.init({ duration: 1000, once: true, offset: 100 });
    setTimeout(function () { AOS.refresh(); }, 500);
  }
});
